<template>
   <span
     class="flex items-center w-fit font-bold"
     :class="[getType(), textColor, textSize, textCase, padding]"
     :style="color ? `background-color: ${color}`:''"
   >
      <slot></slot>
  </span>
</template>

<script>
export default {
    name: 'Badge',
    props:{
      color:{
        type: String,
        default: null
      },
      textColor:{
        type: String,
        default: 'text-white'
      },
      textSize:{
        type: String,
        default: 'text-xs'
      },
      textCase:{
        type: String,
        default: 'uppercase'
      },
      padding:{
        type: String,
        default: 'px-2 py-1'
      },
      type:{
        type: String,
        default: 'badge',
        validator: (type) => ['pill', 'badge'].includes(type)
      },
    },
  methods: {
    getType(){
      switch (this.type) {
        case 'pill': return 'rounded-full';
        case 'badge': return 'rounded-md';
        default: return '';
      }
    }
  }
}
</script>
